import {Card, CardContent, Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {ActiveTrend} from "../../../../types/nbaTypes";
import {TrendCard} from "./TrendCard";
import {useCallback} from "react";

interface ActiveTrendsRowProps {
    teamDisplayName: string
    oTeamDisplayName: string
    sport: string
    teamActiveTrends: ActiveTrend[]
    oTeamActiveTrends: ActiveTrend[]
    underActiveTrends: ActiveTrend[]
    overActiveTrends: ActiveTrend[]
}

export const ActiveTrendsRow = (
    {
        teamDisplayName,
        oTeamDisplayName,
        sport,
        teamActiveTrends,
        oTeamActiveTrends,
        underActiveTrends,
        overActiveTrends,
    }: ActiveTrendsRowProps
) => {

    const emptyTrendsCard = useCallback(() => {
        return (
            <Card
                sx={{
                    width: '97%',
                    marginBottom: '12px',
                }}
            >
                <CardContent>
                    <Typography
                        variant="caption"
                        component="p"
                        align="center"
                    >
                        No Active Trends
                    </Typography>
                </CardContent>
        </Card>
        )
    }, [])

    return (
        <Grid container item xs={12} mt={3} display="flex" justifyContent="space-between">
            <Grid item xs={3} display="flex" flexDirection="column" alignItems="center">
                <Typography component="p" variant="caption" align="center" mb={1} style={{color: 'grey'}}>
                    {teamDisplayName} Trends
                </Typography>
                {teamActiveTrends?.length ? teamActiveTrends?.map((trend: ActiveTrend, index: number) =>
                    (<TrendCard
                        trend={trend}
                        key={index}
                        sport={sport}
                        fullWidth={true}
                    />)
                ) : emptyTrendsCard()}
            </Grid>
            <Grid item xs={3} display="flex" flexDirection="column" alignItems="center">
                <Typography component="p" variant="caption" align="center" mb={1} style={{color: 'grey'}}>
                    {oTeamDisplayName} Trends
                </Typography>
                {oTeamActiveTrends?.length ? oTeamActiveTrends?.map((trend: ActiveTrend, index: number) =>
                    (<TrendCard
                        trend={trend}
                        key={index}
                        sport={sport}
                        fullWidth={true}
                        />
                )) : emptyTrendsCard()}
            </Grid>
            <Grid item xs={3} display="flex" flexDirection="column" alignItems="center">
                <Typography component="p" variant="caption" align="center" mb={1} style={{color: 'grey'}}>
                    Over Trends
                </Typography>
                {overActiveTrends?.length ? overActiveTrends?.map((trend: ActiveTrend, index: number) =>
                    (<TrendCard
                        trend={trend}
                        key={index}
                        sport={sport}
                        fullWidth={true}
                    />)
                ) : emptyTrendsCard()}
            </Grid>
            <Grid item xs={3} display="flex" flexDirection="column" alignItems="center">
                <Typography component="p" variant="caption" align="center" mb={1} style={{color: 'grey'}}>
                    Under Trends
                </Typography>
                {underActiveTrends?.length ? underActiveTrends?.map((trend: ActiveTrend, index: number) =>
                    (<TrendCard
                        trend={trend}
                        key={index}
                        sport={sport}
                        fullWidth={true}
                    />)
                ) : emptyTrendsCard()}
            </Grid>
        </Grid>
    )
}